import { atom } from 'recoil';
import { ATOM_KEYS } from 'utils/const/recoilKeys';
import { LotUnlotteryType } from 'types/api';

export const unlotteryBoxesState = atom<LotUnlotteryType[]>({
  key: ATOM_KEYS.UNLOTTERY_BOXES_STATE,
  default: [],
});
